export default {
  Title: 'New client lead',
  ClientLeadName: 'Client Lead Name',
  ClientLeadDescription: 'Client Lead Description',
  CreateNewClientLead: 'Create new client lead',
};
